export const DEFAULT_CHALLENGE_DETAILS = {
  title: 'Around the world',
  intro:
    '30,365 miles in 80 days. Travel across the globe from Edinburgh to Hong Kong and beyond. Reward yourself and celebrate each milestone.',
  challengeDistance: 30365,
  challengeStartDate: '10/01/2023',
  startDate: '1st Jan 2023',
  endDate: '31st Mar 2023',
};
